<template>
  <div>
    <div v-if="display" class="v-overlay v-overlay--active internal-overlay" style="z-index: 801;"></div>
    <div class="text-xs-center">
      <v-dialog
          :value="display"
          width="700"
          :persistent="true"
      >
        <v-card>
          <v-toolbar card dark color="primary">
            <v-toolbar-title>{{ 'app.pages.home.get_start_discount' | trans }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark small @click="close">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="no-padding">
            <a :href="start_discount_url">
              <v-img src="/img/pages/start-discount/start_discount_modal.png" width="700" class="mx-auto"></v-img>
            </a>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
  props: {
    show_start_discount: {
      type: Boolean
    },
    start_discount_url: {
      type: String
    },
  },
  data: function () {
    return {
      display: false
    };
  },
  mounted() {
    if(this.show_start_discount){
      if(VueCookies.isKey('start-discount-modal')){
        this.display = false;
      } else{
        VueCookies.set('start-discount-modal', 'true', 60 * 60 * 6);
        this.display = true;
      }

      if (this.display) {
        setTimeout(() => {
          const overlayFromOtherVueInstance = document.querySelector('div.v-overlay.v-overlay--active:not(.internal-overlay)');
          if (overlayFromOtherVueInstance) {
            overlayFromOtherVueInstance.style.display = 'none';
          }
        }, 1000);
      }
    }
  },
  methods: {
    close: function () {
      this.display = false;
    }
  }
}
</script>